// extracted by mini-css-extract-plugin
export var button = "_ca-0";
export var icon = "_ca-1";